import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { toast } from 'sonner';
import { Shield } from 'lucide-react';

const ROLES = [
  { value: 'member', label: 'Member', desc: 'No admin access' },
  { value: 'dept_leader', label: 'Dept Leader', desc: 'Events for their department' },
  { value: 'cfo', label: 'CFO / Finance', desc: 'Settings, giving, gallery' },
  { value: 'secretary', label: 'Secretary', desc: 'News, events, contacts' },
  { value: 'bishop', label: 'Bishop', desc: 'Leaders, events, news, timeline' },
  { value: 'prelate', label: 'Prelate', desc: 'Full admin — all tabs' },
  { value: 'admin', label: 'Admin', desc: 'Full admin — all tabs' },
];

export default function UsersEditor() {
  const [users, setUsers] = useState([]);
  const load = () => api.get('/admin/users').then(r => setUsers(r.data)).catch(() => toast.error('Load failed'));
  useEffect(() => { load(); }, []);
  const setRole = async (id, role) => {
    try { await api.patch(`/admin/users/${id}`, { role }); toast.success('Role updated'); load(); }
    catch { toast.error('Update failed'); }
  };
  return (
    <div>
      <h3 className="font-serif text-xl text-royal font-bold mb-4">Users & Roles ({users.length})</h3>
      <div className="text-sm text-charcoal-muted mb-6 max-w-3xl">Assign roles to members so they can help manage parts of the site. Each role sees only the tabs relevant to their responsibilities.</div>
      <div className="grid gap-3">
        {users.map(u => (
          <div key={u.user_id} className="bg-white border rounded-lg p-4 flex items-center gap-4">
            {u.picture ? <img src={u.picture} alt="" className="w-12 h-12 rounded-full" /> : <div className="w-12 h-12 rounded-full bg-royal/10 text-royal flex items-center justify-center font-serif">{u.name?.[0] || 'U'}</div>}
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-royal truncate">{u.name}</div>
              <div className="text-xs text-charcoal-muted truncate">{u.email}</div>
            </div>
            <div className="flex items-center gap-2">
              <Shield className="w-4 h-4 text-gold" />
              <select value={u.role || 'member'} onChange={(e) => setRole(u.user_id, e.target.value)} data-testid={`user-role-${u.user_id}`} className="border rounded px-3 py-2 text-sm">
                {ROLES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
              </select>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8 bg-white border rounded-lg p-6">
        <h4 className="font-semibold text-royal mb-3">Role Permissions</h4>
        <ul className="text-sm text-charcoal-muted space-y-2">
          {ROLES.map(r => <li key={r.value}><strong className="text-royal">{r.label}</strong> — {r.desc}</li>)}
        </ul>
      </div>
    </div>
  );
}
